import { min, map, uniq, filter, minBy } from 'lodash';

export const getPackagePricing = (products) => {
  const lowestPrice = min(map(products, 'price'));
  const uniquePrices = uniq(map(products, 'price'));
  const lowestPricedProducts = filter(products, ['price', lowestPrice]);
  const lowestPriceLowestOriginalPrice = minBy(lowestPricedProducts, 'originalPrice');

  return {
    uniquePrices,
    lowestPriceLowestOriginalPrice,
  };
};

export const showOriginalPricing = ({ price, originalPrice }) => originalPrice > price;
